import styled from "styled-components";
import { device } from "../device";

export const CompaniesContentGrid = styled.ul`
    position: relative;
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    column-gap: 24px;
    row-gap: 24px;
    margin-bottom: 24px;
    width: 100%;
    flex-flow: row wrap;
    align-items: stretch;
    justify-content: flex-start;
    margin-left: 0;
    padding-inline-start: 0;
    margin-top: 0;

    li {
      list-style: none;
      cursor: pointer;
    }
    li>div {
        height: 100%;
    }

     @media ${device.tablet} {
      column-gap: 32px;
      row-gap: 32px;
      margin-bottom: 32px;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    }

    @media ${device.laptop} {
      column-gap: 32px;
      row-gap: 32px;
      margin-bottom: 32px;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
    }
`;

export const CompaniesGridItem = styled.div`
  a {
      flex-direction: column;
      width: 100%;
      height: 100%;
      text-decoration: none;
      background-color: #fff;
      display: flex;
      border-radius: 16px;
      overflow: hidden;
      z-index: 0;
      position: relative;

      &:hover {
          .card-media::after {
              background: rgba(0,0,0,0.15);
          }

          .card-media {
            img {
                transform: scale(1.03);
            }
          }
      } 
    }
`;

export const CompanyCardHeader = styled.div`
  position: relative;
  width: 100%;
  min-height: 160px;

      &::after {
        content: '';
        display: inline-block;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        -webkit-transition: background 400ms cubic-bezier(0.4, 0, 0.25, 1) 0ms;
        transition: background 400ms cubic-bezier(0.4, 0, 0.25, 1) 0ms;
      }

      img {
          transition: opacity 1s cubic-bezier(0.4, 0, 0.25, 1) 0ms,transform 400ms cubic-bezier(0.4, 0, 0.25, 1) 0ms,-webkit-transform 400ms cubic-bezier(0.4, 0, 0.25, 1) 0ms;
          object-fit: cover;
      }
`;


export const CompanyCardContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  padding-top: 0;
  margin-top: -40px;
  column-gap: 20px;
  align-items: center;
  text-align: center;

  .logo {
    position: relative;
    height: 80px;
    width: 80px;
    margin-bottom: 20px;
    z-index: 3;
  }
  .company-text-content {
    display: flex;
    flex-direction: column;
    h1 {
        font-weight: 700;
        font-size: 20px;
        line-height: 25px;
        margin-top: 0;
        margin-bottom: 4px;
      }
      p {
        margin-top: 0;
        margin-bottom: 16px;
        font-weight: normal;
        font-size: 17px;
        line-height: 25px;
      }
  }

`;